import { TweenMax } from 'gsap';
import { Sprite } from 'pixi.js';
import { GameAudio } from '../../../Config/Audio';
import { getGameSize } from '../../../Config/Levels';
import SoundManager from '../../../Sound/SoundManager';
import { Animation } from '../Animation';
import Core, { GameOrientation } from '../../../Core/Core';

/**
 *
 * @param pos - ui highlight booster button position
 * @param dimBoard - function to darken all tiles
 * @param revealBoard - function to highlight all tiles
 * @param c - container sprite
 */
export const showHighlightBooster = async (
    pos: PIXI.Point,
    dimBoard: (ms: number) => void,
    revealBoard: (ms: number) => void,
    c: PIXI.Container
) => {
    const flashlight = new Sprite(PIXI.utils.TextureCache['mapui/booster-highlight']);
    flashlight.anchor.set(0.5);
    flashlight.x = pos.x;
    flashlight.y = pos.y;
    const beam = new Sprite(PIXI.utils.TextureCache['gameui/booster-highlight-beam']);
    beam.scale.set(1.6);
    beam.alpha = 0;

    const animation = new Animation({});
    animation.add(() => dimBoard(300));
    animation.add(() => c.addChild(flashlight));
    animation.add(() => SoundManager.playSound(GameAudio.BOOSTER_IN));

    const size = getGameSize();
    if (Core.orientation === GameOrientation.PORTRAIT) {
        animation.add(
            TweenMax.to(flashlight, 0.5, {
                x: size.gameWidth * 0.1,
                y: size.gameHeight * 0.8,
                rotation: 70 * (Math.PI / 180),
            })
        );
    } else {
        animation.add(
            TweenMax.to(flashlight, 0.5, {
                x: size.xOffset - size.gameWidth * 0.05,
                y: size.yOffset + size.gameHeight * 0.9,
                rotation: 70 * (Math.PI / 180),
            })
        );
    }

    animation.addToLast(TweenMax.to(flashlight.scale, 0.6, { x: 1.6, y: 1.6 }));
    animation.addDelay(200);
    animation.add(() => SoundManager.playSound(GameAudio.FLASHLIGHT_CLICK));
    animation.add(() => {
        beam.x = flashlight.x + flashlight.width * 0.05;
        beam.y = flashlight.y - flashlight.height * 1.4;
        c.addChild(beam);
    });
    animation.add(() => SoundManager.playSound(GameAudio.FLASHLIGHT));
    animation.add(TweenMax.to(beam, 0.3, { alpha: 1 }));
    animation.add(() => revealBoard(300));

    await animation.play();

    const outAnimation = new Animation({});
    outAnimation.add(() => SoundManager.playSound(GameAudio.FLASHLIGHT_CLICK));
    outAnimation.add(
        TweenMax.to(beam, 0.3, {
            alpha: 0,
        })
    );

    outAnimation.add(() => SoundManager.playSound(GameAudio.BOOSTER_OUT));
    outAnimation.add(
        TweenMax.to(flashlight, 0.6, {
            x: pos.x,
            y: pos.y,
            rotation: 0,
        })
    );
    outAnimation.addToLast(
        TweenMax.to(flashlight.scale, 0.6, {
            x: 1,
            y: 1,
        })
    );
    outAnimation.add(() => {
        beam.destroy();
        flashlight.destroy();
    });

    return outAnimation;
};
